import IconType from "@/components/IconType";
import {
  CARDIOMETABOLIC_ICON_TYPE,
  DETOXIFICATION_METHYLATION_ICON_TYPE,
  ENDOCRINE_ICON_TYPE,
  NUTRITION_ICON_TYPE
} from "@/core/constants";
const REGENERUS_LOGO_SRC = "/email-images/regenerus-logo-for-email-template.svg";

const COVER_ILLUSTRATION_SRC = {
  [DETOXIFICATION_METHYLATION_ICON_TYPE]: "/report-print/cover-illustration-methylation.png",
  [NUTRITION_ICON_TYPE]: "/report-print/cover-illustration-nutrition.png",
  [ENDOCRINE_ICON_TYPE]: "/report-print/cover-illustration-endocrine.png",
  [CARDIOMETABOLIC_ICON_TYPE]: "/report-print/cover-illustration-cardiometabolic.png"
};

function CoverIllustration({ reportIcon }) {
  const src =
    COVER_ILLUSTRATION_SRC[reportIcon] || COVER_ILLUSTRATION_SRC[DETOXIFICATION_METHYLATION_ICON_TYPE];

  return <img src={src} alt="" className="cover-illustration-image" />;
}

function CoverField({ label, value }) {
  return (
    <span className="cover-field">
      <span className="cover-field-label">{label}</span>
      <span className="cover-field-separator">|</span>
      <span className="cover-field-value">{value || "—"}</span>
    </span>
  );
}

export default function Cover({ reportIcon, reportName, fullName, dateOfBirth, dateReported, orderNumber }) {
  return (
    <div className="cover-page">
      <header className="cover-header">
        <img src={REGENERUS_LOGO_SRC} alt="Regenerus Labs" className="cover-logo" />
      </header>

      <div className="cover-title-row">
        {reportIcon && (
          <div className="cover-icon">
            <IconType iconType={reportIcon} iconSize={80} withCircle color="#1A1A1A" />
          </div>
        )}
        <h1 className="cover-report-name">{reportName || "—"}</h1>
      </div>

      <div className="cover-metadata">
        <CoverField label="User" value={fullName} />
        <CoverField label="DOB" value={dateOfBirth} />
        <CoverField label="Date Reported" value={dateReported} />
        {orderNumber && <CoverField label="Order No" value={orderNumber} />}
      </div>

      <div className="cover-illustration-frame">
        <div className="cover-illustration-panel">
          <CoverIllustration reportIcon={reportIcon} />
        </div>
      </div>

      <footer className="cover-disclaimer">
        <h2 className="cover-disclaimer-heading">Disclaimer</h2>
        <p className="cover-disclaimer-text">
          This report is a prototype intended for demonstration purposes only. The structure, design and content are
          subject to change. Final reports might differ in format and presentation.
        </p>
      </footer>
    </div>
  );
}
